/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';
import {MarketplaceProductListPageComponent} from './marketplace-product-list-page.component';

@Component({
  standalone: true,
  imports: [MarketplaceProductListPageComponent],
  selector: 'adn-marketplace-product-route-page',
  template: `
    <adn-marketplace-product-list-page
      [readOnly]="readOnly">
    </adn-marketplace-product-list-page>
  `
})
export class MarketplaceProductRoutePageComponent implements OnInit {
  readOnly = true;

  constructor(
    @Inject(LocalUserPermissions) private LocalUserPermissions: any
  ) {}

  ngOnInit(): void {
    const perms = this.LocalUserPermissions.getAllNetworkPermissions();
    this.readOnly = !perms.AX_PUBLISHER_ADMIN && !perms.MANAGE_SYSTEM;
  }
}
